// Material components
import {SvgIcon} from '@material-ui/core';
import React from 'react';

export default function RightArrow(props: any) {
    return (
        <SvgIcon viewBox="0 0 24 15" {...props}>
            <path d="M16.569 6.395l-3.917-3.73a1 1 0 011.379-1.449l6.488 6.179-6.488 6.179a1 1 0 01-1.379-1.448l3.917-3.731h-15.5a1 1 0 010-2h15.5z" fill="#fff"/>
        </SvgIcon>
    );
}